import axios from "axios";
class AuthService {
  login(sess_id) 
  {
    return axios
      .post( "/Login", { sess_id })
      .then((response) => {
       if (response.data.code == 100) 
       {
        sessionStorage.setItem('sess_id', response.data.mnemonic);
       }
        return response.data;
      });
  }
  logout() 
  {
    sessionStorage.removeItem('sess_id');
  }
}

export default new AuthService();
